import moment from "moment";

export function getSubsProgress(start_date, expire_date) {
  const startDate = moment(start_date).tz("Asia/Kolkata");
  const expireDate = moment(expire_date).tz("Asia/Kolkata");
  const currentDate = moment().tz("Asia/Kolkata");

  if (startDate.isAfter(currentDate) || expireDate.isBefore(currentDate)) {
    const totalDuration = expireDate.diff(startDate, "days");
    const res = {
      daysLeft: startDate.isAfter(currentDate) ? totalDuration : 0,
      percentageConsumed: 0,
    };
    return res;
  }

  const totalDuration = expireDate - startDate;
  const consumedDuration = currentDate - startDate;
  const percentageConsumed = (consumedDuration / totalDuration) * 100;
  const daysLeft = expireDate.diff(currentDate, "days");
  const res = {
    daysLeft,
    percentageConsumed: percentageConsumed || 100,
  };

  return res;
}

export const taeeExportable = [
  "all",
  "regular_subscription_status",
  "regular_expire_date",
  "member_name",
  "member_mobile",
  "member_email",
  "gym_name",
  "plan_name",
  "duration",
  "trainer_name",
  "price",
  "last_checkin",
  "last_checkin_days_ago",
  "checkin_time",
  "date_added",
  "expire_date",
  "start_date",
  "consumed_session",
  "n_session",
  "subscription_status",
];

export const ptTrialExportable = [
  "all",
  "converted",
  "converted_price",
  "converted_date_added",
  "converted_start_date",
  "converted_expire_date",
  "converted_n_session",
  "converted_trainer_name",
  "converted_trainer_email",
  "converted_trainer_mobile",
  "regular_subscription_status",
  "regular_expire_date",
  "member_profile",
  "member_name",
  "member_mobile",
  "member_email",
  "gym_name",
  "plan_name",
  "duration",
  "trainer_name",
  "start_time",
  "end_time",
  "price",
  "last_checkin",
  "last_checkin_days_ago",
  "checkin_time",
  "is_partial",
  "date_added",
  "expire_date",
  "start_date",
  "consumed_session",
  "n_session",
  "is_trial",
  "session_status",
  "last_session",
  "subscription_status",
];
